import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  TASK_PRIORITY_LIST: 'task-priority'
}

const routes = [
  {
    path: 'task-priority/',
    name: ROUTES.TASK_PRIORITY_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['tasks_taskpriority_list'],
      requiresAuth: true
    },
    component: () => import('./TaskPriorityList.vue')
  }
]

export { routes, ROUTES }
